import React from "react";
import { FieldProps as Props } from "./interfaces";
import EmployeeSurveyContent from "../EmployeeSurveyContent/EmployeeSurveyContent";

const EditEmployeeSurveyFields = ({ item, handleChangeSurveyItem }: Props) => {
  return (
    <>
      <EmployeeSurveyContent
        survey={item}
        handleChangeSurveyItem={handleChangeSurveyItem}
      />
    </>
  );
};

export default EditEmployeeSurveyFields;
